import {createAnatomy} from '@zag-js/anatomy';

export const feedbackLayoutAnatomy = createAnatomy(`feedback-layout`).parts(
  `container`,
  `body`,
  `title`,
  `description`,
  `img`,
  `player`,
);

export const parts = feedbackLayoutAnatomy.build();

export type Part = keyof typeof parts;
